<template>
    <div class="mt-4">
        <b-overlay
            :show="dataOverlay"
            spinner-variant="success"
        >
            <template v-if="items.length == 0">
                <div class="tsoft-alert mb-2">
                    <span>Нет добавленных документов</span>
                </div>
            </template>

            <template v-else>
                <div class="row pl-3 pr-3 mt-3">
                    <div class="col-md-12" v-for="(item, index) in items" :key="index">
                        <div class="row list-block shadow align-items-center mb-3 list-block__download">
                            <div class="list-block_doc ml-3">
                                <a class="cursor-pointer d-block position-relative" @click.prevent="openFile(item)">
                                    <img :id="'doc-logo-'+index" :src="'/img/icon-document.svg'" style="width: 44px;">
                                    <div class="list-block_doc_extention">{{ fileExtension(item.path) }}</div>
                                </a>

                            </div>
                            <div class="list-block_text ml-3">
                                <ul class="mb-0">
                                    <li>
                                        <span class="text-secondary">Наименование документа:</span>
                                        <span class="font-weight-bold text-uppercase text-brown ml-2">{{ item.name }}</span>
                                    </li>
                                    <li>
                                        <span class="text-secondary">Описание документа:</span>
                                        <span class="ml-2">{{ item.description ? item.description : '-' }} </span>
                                    </li>
                                    <li>
                                        <span class="text-secondary">Создан:</span>
                                        <span class="text-brown ml-2">{{ item.created_at }}</span>
                                        <template v-if="item.creator">
                                            <span class="text-brown ml-1">|</span>
                                            <span class="text-brown ml-1">{{ item.creator.name }}</span>
                                        </template>
                                    </li>
                                </ul>
                            </div>
                            <div class="d-flex align-items-center ml-auto">
                                <div class="list-block_type ml-3">
                                    <span class="text-secondary font-weight-bold text-uppercase">{{ item.type ? item.type.name : '-' }}</span>
                                </div>
                                <div class="list-block_action ml-3">
                                    <a :href="hfs + item.path" download class="list-block_icon cursor-pointer p-1">
                                        <i class="fas fa-download"></i>
                                    </a>
                                </div>
                                <div class="list-block_action ml-3">
                                    <span class="list-block_icon cursor-pointer p-1" @click="openFile(item)">
                                        <i class="far fa-eye"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <div class="table-pagination-block mt-2">
                <div v-if="total > perPage || items.length > perPage">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="total"
                        :per-page="perPage"
                        :current-page="currentPage"
                        aria-controls="main-table"
                        size="md"
                        class="my-0"
                        pills
                    ></b-pagination>
                </div>
                <div 
                    v-if="items.length > pageOptions[0] || total > perPage || items.length > perPage"
                    class="align-items-center d-flex position-absolute table-pagination__perpage"
                >
                    <div class="font-size-12 text-secondary mr-1">
                        <span>Показывать по</span>
                    </div>
                    <div>
                        <b-form-select
                            v-model="perPage"
                            id="perPageSelect"
                            class="table-select-perpage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import {HOST_FOR_STORAGE, API_DOCUMENTS } from '@/constants';
import { defaultDataItems } from '@/mixins';

export default {
mixins: [
    defaultDataItems
],
    props: {
        updateListDocument: { type: Array, required: false },
        orderId: { type: Number | String, required: false, default: '' },           //order id for showing documents
        creatorUserId: { type: Number | String, required: false, default: '' },     //creator user id for showing documents
        orderServiceId: { type: Number | String, required: false, default: '' },    //order service id for showing documents
        companyId: { type: Number | String, required: false, default: '' },         //company id for showing documents
        financeId: { type: Number | String, required: false, default: '' },         //finance id for showing documents
        taskId: { type: Number | String, required: false, default: '' },            //task id for showing documents
        referenceDocumentTypeIds: { type: Array,
            required: false,
            default: function () {
                return []
            }
        },                                                                           //array of document type id for searching
        requestDocuments: { type: Boolean, default: false, required: false },       //activation of the component work process
        updateDocumentList: { type: Number, default: 1, required: false },          //activation of the component work process
        excludeAddDocumentTypeArray: {  type: Array,
            required: false,
            default: function () {
                return [329, 330, 331, 332, 333, 338]
            }
        },                                                                          //if you need to exclude document type for adding
    },
    data() {
        return {
            items: [],
            dataOverlay: true,
            hfs: HOST_FOR_STORAGE,
            perPage: 5,
            currentPage: 1,
            total: 0,
            pageOptions: [5, 25, 50],
            lastPage: 1
        }
    },
    watch: {
        requestDocuments: function(val){
            if (val == true) {
                this.showDocuments()
            }
        },
        updateDocumentList: {
            handler(newVal, oldVal) {
                if (newVal != oldVal && this.requestDocuments) {
                    this.showDocuments()
                }
            }
        },
        updateListDocument: function(val){
            for(let i = 0; i < val.length; i++){
                this.items.push(val[i])
                if (i + 1 === val.length) {
                    this.$emit('clearDocumentList')
                }
            }
        },
        'items.length': function() {
            if (this.items.length > this.perPage || (this.items.length < this.perPage && this.currentPage !== this.lastPage)) {
                this.showDocuments();
            }
            if (this.items.length === 0 && this.currentPage !== 1) {
                this.currentPage -= 1;
            }
        },
        currentPage: function() {
            this.showDocuments();
        },
        perPage: function() {
            this.currentPage = 1;
            this.showDocuments();
        }
    },
    mounted() {
        if (this.requestDocuments) {
            this.showDocuments()
        }
    },
    methods: {
        ...mapActions('fileViewer', ['viewFile']),
        openFile(item) {
            if (this.fileExtension(item.path) !== 'txt') {
                this.viewFile({name: item.name, src: this.hfs + item.path})
            } else {
                window.open(this.hfs + item.path, '_blank');
            }
        },
        //list uploaded documents
        showDocuments() {
            let additionalGetParameter = ''

            additionalGetParameter += (this.orderId ? `&order_id=${this.orderId}`: '');
            additionalGetParameter += (this.creatorUserId ? `&creator_user_id=${this.creatorUserId}`: '');
            additionalGetParameter += (this.orderServiceId ? `&order_service_id=${this.orderServiceId}`: '');
            additionalGetParameter += (this.companyId ? `&company_id=${this.companyId}`: '');
            additionalGetParameter += (this.financeId ? `&finance_id=${this.financeId}`: '');
            additionalGetParameter += (this.taskId ? `&task_id=${this.taskId}` : '');
            additionalGetParameter += (this.referenceDocumentTypeIds ? `&reference_document_type_ids=${this.referenceDocumentTypeIds}`: '');

            api.call('get', `${API_DOCUMENTS}?${additionalGetParameter}&page=${this.currentPage}&per_page=${this.perPage}`)
            .then(({data}) => {
                this.items = data.data;
                this.total = data.total;
                this.lastPage = data.last_page;
            })
            .finally(() => {
                this.dataOverlay = false
            })
        },
    },
}
</script>
